const Home = () => {
    return (
        <svg
            width={20}
            height={19}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity=".4"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.552 10.592a.912.912 0 0 1-1.286 0 .902.902 0 0 1 0-1.28L9.357.266a.912.912 0 0 1 1.286 0l9.09 9.048a.902.902 0 0 1 0 1.28.912.912 0 0 1-1.285 0l-.266-.266v6.868A1.81 1.81 0 0 1 16.362 19H3.638a1.812 1.812 0 0 1-1.819-1.805v-6.868l-.266.265Zm2.085 6.598 2.727.001V11.76c0-.499.406-.903.906-.903h5.46c.5 0 .906.404.906.903v5.433l2.728.002V8.519L10 2.192 3.636 8.519l.001 8.671Zm8.181-4.525v4.527H8.182v-4.525l3.636-.002Z"
                fill="#fff"
            />
        </svg>
    );
};

export default Home;
